import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import TextField from '@material-ui/core/TextField';
import InputAdornment from '@material-ui/core/InputAdornment';
import CircularProgress from '@material-ui/core/CircularProgress';
import { FormatError } from '../../services/error';
import './ValidatingTextField.scss';

const ValidatingTextField = (props) => {
  const { value, onChange, validateValue, className, convertValue, label, variant, style, autoFocus } = props;
  const timeout = useRef(null);
  const [{ validating, error }, setValidating] = useState({ validating: false, error: null });
  const [editingValue, setEditingValue] = useState(value);

  useEffect(() => {
    setValidating({ validating: false, error: null });
    setEditingValue(value);
  }, [value]);

  // const { licenseService, history, location } = props;
  const handleChange = useCallback((event) => {
    if (timeout.current) {
      clearTimeout(timeout.current);
    }
    const fieldValue = event.target.value;
    setEditingValue(fieldValue);
    timeout.current = setTimeout(() => {
      timeout.current = null;
      if (validateValue) {
        setValidating({ validating: true, error: null });
        validateValue(fieldValue)
        .then((res) => {
          setValidating({ validating: false, error: null });
          onChange(convertValue ? res : fieldValue);
        })
        .catch((e) => {
          let message;
          if (typeof e === 'string') {
            message = e;
          } else if (e.message) {
            message = e.message;
          } else {
            message = FormatError(e);
          }
          setValidating({ validating: false, error: message });
        });
      }
    }, 500);
  }, [validateValue, convertValue, onChange]);

  return (
    <TextField
      className={classnames('grb-validating-textfield', className, validating && 'grb-validating-textfield-loading', error && 'grb-validating-textfield-error')}
      value={(editingValue === undefined) || (editingValue === null) ? '' : editingValue}
      label={label}
      variant={variant}
      style={style}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <CircularProgress size={18} style={{ visibility: validating ? 'visible' : 'hidden' }} />
          </InputAdornment>
        ),
      }}
      // eslint-disable-next-line react/jsx-no-duplicate-props
      inputProps={{ autoFocus }}
      error={!!error}
      helperText={error || undefined}
      onChange={handleChange}
    />
  );
};

ValidatingTextField.propTypes = {
  className: PropTypes.string,
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ]),
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  validateValue: PropTypes.func,
  convertValue: PropTypes.bool,
  variant: PropTypes.string,
  style: PropTypes.shape({}),
  autoFocus: PropTypes.bool,
};

ValidatingTextField.defaultProps = {
  className: undefined,
  value: undefined,
  validateValue: undefined,
  convertValue: false,
  label: undefined,
  variant: undefined,
  style: undefined,
  autoFocus: undefined,
};

export default ValidatingTextField;
